module.exports = __webpack_public_path__ + "img/logo-mepyd.a910c7a2.webp";